import React from 'react';
import { Button } from '../ui/button';
import { Send } from 'lucide-react';

const ChatInput = ({ inputRef, input, setInput, onSend, loading, mode, selectedDoc }) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  return (
    <div className="border-t border-slate-200 p-3 bg-white">
      {mode === 'suggest' && !selectedDoc && (
        <p className="text-xs text-amber-600 mb-2 text-center">
          Select a document first to suggest changes
        </p>
      )}
      <div className="flex gap-2">
        <textarea
          ref={inputRef}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={
            mode === 'suggest'
              ? 'Describe the changes you want...'
              : 'Ask a question about this project...'
          }
          className="flex-1 resize-none rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#2B8FD8] focus:border-transparent min-h-[40px] max-h-[120px]"
          rows={1}
          disabled={loading || (mode === 'suggest' && !selectedDoc)}
        />
        <Button
          onClick={onSend}
          disabled={!input.trim() || loading || (mode === 'suggest' && !selectedDoc)}
          className={`h-10 w-10 p-0 shrink-0 ${
            mode === 'suggest' ? 'bg-amber-500 hover:bg-amber-600' : 'bg-[#2B8FD8] hover:bg-[#2075b3]'
          }`}
        >
          <Send className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default ChatInput;
